import styled from '@emotion/styled';
import React from 'react';

interface IPProps {
	children: React.ReactNode;
}

const StyledP = styled.p`
	color: rgba(17, 34, 58, 0.65);
	font-size: 16px;
	font-family: Inter;
	line-height: 150%;
	letter-spacing: -0.18px;
	margin: 0;
`;

export const P = ({ children }: IPProps) => {
	return <StyledP>{children}</StyledP>;
};
